export const getSort = (searchParams: URLSearchParams) => {
  return {
    sortField: searchParams.get('sortField') || 'identifier',
    sortDir: searchParams.get('sortDir') || 'asc',
  }
}
